export default {
  buttons: {
    more_payment_methods: 'Meer betaalmethoden',
  },
  toasts: {
    processing: 'Betalingsgegevens worden verwerkt. We laten u weten wanneer de verwerking voltooid is.',
    failed: 'Verwerking van betalingsgegevens mislukt. Probeer een andere betaalmethode.',
    failed_to_load: 'Het betaalformulier kon niet worden geladen. Laad de pagina opnieuw en probeer het nog eens.',
    failed_to_save_payment_method: 'Opslaan van betaalmethode mislukt',
    failed_to_create_checkout_session: 'Er is iets misgegaan, probeer het opnieuw',
  },
};
